import React from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";

import DropdownMenu from "../../../ui/components/DropdownMenu/DropdownMenu";
import ErrorMessage from "../../../ui/components/Messages/ErrorMessage";
import Message from "../../../ui/components/Messages/Message";
import SecondaryMenu from "../../../ui/components/SecondaryMenu/SecondaryMenu";
import useBreadcrumbs from "../../../ui/hooks/useBreadcrumbs";
import PageView from "../../../ui/views/PageView/PageView";

import ArtifactStatusLabels from "../../components/ArtifactStatus/ArtifactStatusLabels";
import useArtifactDropdownMenuOptions from "../../hooks/useArtifactDropdownMenuOptions";

export default function ArtifactView({ work, disabled, article, artifact, production, children }) {
	const { t } = useTranslation();
	const { pathname } = useLocation();

	const breadcrumbs = useBreadcrumbs({ work, article, artifact, production });

	const dropdownMenuOptions = useArtifactDropdownMenuOptions({ disabled, article, production });

	return (
		<PageView
			maxWidth={1400}
			breadcrumbs={breadcrumbs}
			header={artifact.name}
			subheader={t("amountFiles", "{{amount}} files", { amount: artifact.files.length })}
			extra={
				<>
					<ArtifactStatusLabels artifact={artifact} article={article} production={production} />

					<DropdownMenu options={dropdownMenuOptions(artifact)} />
				</>
			}
		>
			{artifact.error && <ErrorMessage>{artifact.error}</ErrorMessage>}

			{artifact.warnings?.map((warning, index) => (
				<Message key={index} warning>
					{warning}
				</Message>
			))}

			{!artifact?.contentType?.includes?.("epub") && (
				<SecondaryMenu
					options={[
						{
							key: "files",
							name: "Files",
							path: ".",
							active: !pathname.includes("exports"),
						},
						{
							key: "exports",
							name: "Exports",
							path: "./exports",
							active: pathname.includes("exports"),
						},
					]}
				/>
			)}

			{children}
		</PageView>
	);
}
